import apiClient from "../api/client";
import {
  PagedStoresResponse,
  UpdateStoreRequest,
  Trait,
  StoresListToPublish,
  StoresCount,
  StoreLanguagesResponse,
  AddStoreDto,
  StoreDropdownDto
} from "../types/storetypes";

export async function getAllStores(): Promise<StoresListToPublish[]> {
  const response = await apiClient.get<StoresListToPublish[]>(
    "/api/Stores/GetAll"
  );
  return response.data;
}

export async function getStoresCount(): Promise<StoresCount> {
  const response = await apiClient.get<StoresCount>(
    "/api/Stores/Count"
  );
  return response.data;
}

export async function getPagedStores(
  params: Record<string, any>
): Promise<PagedStoresResponse> {
  const response = await apiClient.get<PagedStoresResponse>(
    "/api/Stores/GetPagedStores",
    { params }
  );
  return response.data;
}

export async function getTraitsForStore(
  storeGuid: string
): Promise<string[]> {
  const response = await apiClient.get<Trait[]>(
    "/api/Stores/GetTraitsForStoreById",
    { params: { Id: storeGuid } }
  );

  return [...new Set(response.data.map((item) => item.guid))];
}

export async function updateStoreDetails(
  storeUpdateData: UpdateStoreRequest
): Promise<void> {
  await apiClient.put(
    "/api/Stores/UpdateStoreDetails",
    storeUpdateData
  );
}

export async function getLanguagesForStore(
  storeGuid: string
): Promise<StoreLanguagesResponse | null> {
  const response = await apiClient.get<StoreLanguagesResponse>(
    "/api/Stores/GetLanguagesForStoreById",
    { params: { Id: storeGuid } }
  );

  return response.data;
}

export const addStore = async (dto: AddStoreDto) =>
  apiClient.post("/api/stores/add", dto);

export const getAllStoresForDropdown = () =>
  apiClient.get<StoreDropdownDto[]>("/api/Stores/GetAll");

export interface PagedStoreDropdownResponse {
  data: StoreDropdownDto[];
  totalCount: number;
}

export const getPagedStoresForDropdown = async (params: { pageNumber: number; pageSize: number; searchText?: string }) => {
  const response = await apiClient.get<PagedStoreDropdownResponse>("/api/Stores/GetPagedStoresForDropdown", { params });
  return response.data;
};

export const getStoreDetails = async (storeGuid: string) => {
  const res = await apiClient.get(
    "/api/Stores/GetStoreDetails",
    {
      params: { Id: storeGuid }
    }
  );
  return res.data;
};
